var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',{ref:"base",attrs:{"on-submit":(params) => _vm.projectsService.createFormTemplate(params),"on-get":(id) => _vm.projectsService.getTemplateById(id),"triger-prevent":_vm.trigerPrevent,"field-details-route":"content-field-details","templates-route":"content-templates","show-teams":false,"is-one":true,"group-name":"Main Topic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }